import { AxiosPromise } from 'axios';
import { IEventAttendanceReq, IEventParams, IEventRegisterParams, IEventRegisterReq, IGetEvent, IGetEventCampus, IGetEventInfo, IGetEventParticipant, IGetEventRegister, IGetEvents, IGetParents } from '../models/events.model';
import axios from 'axios';
import QueryString from 'qs';

const uri = '/mgmt/events';
const homeUri = '/home/events';

// BR0006 = 행사유형
export const getEvents = (BR0006: string, params: IEventParams): AxiosPromise<IGetEvents> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/${BR0006}?${qsParams}`);
}

export const getEvent = (BR0006: string, eventNo: number): AxiosPromise<IGetEvent> => {
  return axios.get(`${uri}/${BR0006}/${eventNo}`);
}

export const createEvent = (BR0006: string, data: FormData): AxiosPromise => {
  return axios.post(`${uri}/${BR0006}`, data);
};

export const updateEvent = (BR0006: string, eventNo: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${BR0006}/${eventNo}`, data);
};

export const getEventInfo = (BR0006: string, eventNo: number): AxiosPromise<IGetEventInfo> => {
  return axios.get(`${uri}/${BR0006}/${eventNo}/event-info`);
}

export const getEventRegister = (BR0006: string, eventNo: number, params: IEventRegisterParams): AxiosPromise<IGetEventRegister> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/${BR0006}/${eventNo}/require-list?${qsParams}`);
}

export const createEventRegister = (BR0006: string, eventNo: number, data: IEventRegisterReq[]): AxiosPromise => {
  return axios.post(`${uri}/${BR0006}/${eventNo}/require`, data);
};

export const createEventAttendance = (eventRequireCode: number, data: IEventAttendanceReq): AxiosPromise => {
  return axios.put(`${uri}/attendance/${eventRequireCode}`, data);
};

export const cancelEventRegister = (eventNo: number, data: { eventRequireCode: number }[]): AxiosPromise => {
  return axios.put(`${uri}/cancel/${eventNo}`, data);
}

export const cancelEventAttendance = (eventRequireCode: number): AxiosPromise => {
  return axios.put(`${uri}/attend-cancel/${eventRequireCode}`);
}

export const getParents = (eventNo: number): AxiosPromise<IGetParents> => {
  return axios.get(`${uri}/parents-list/${eventNo}`);
}

export const getEventCampus = (eventNo: number): AxiosPromise<IGetEventCampus> => {
  return axios.get(`${homeUri}/attendance-system/${eventNo}`);
}

export const getEventParticipant = (eventNo: number, data: { mobilePhone: string; }): AxiosPromise<IGetEventParticipant> => {
  return axios.post(`${homeUri}/attendance-system/${eventNo}`, data);
}
